import { config } from '~/config/app.config';

export const APP_BASE_PATH = config.app.basePath;
export const APP_LEGACY_BASE_PATH = '/app';
const ALL_BASE_PATHS = [APP_BASE_PATH, APP_LEGACY_BASE_PATH];

const normalizePathname = (pathname: string) => {
  if (!pathname) {
    return '/';
  }

  return pathname !== '/' && pathname.endsWith('/')
    ? pathname.slice(0, -1)
    : pathname;
};

const withAppBase = (path = '') => {
  if (!path || path === '/') {
    return APP_BASE_PATH;
  }

  return `${APP_BASE_PATH}${path.startsWith('/') ? path : `/${path}`}`;
};

const withoutAppBase = (path: string) => {
  const normalizedPath = normalizePathname(path);

  for (const basePath of ALL_BASE_PATHS) {
    if (
      normalizedPath === basePath ||
      normalizedPath.startsWith(`${basePath}/`)
    ) {
      const unprefixedPath = normalizedPath.slice(basePath.length);

      return unprefixedPath || '/';
    }
  }

  return normalizedPath;
};

export const getRouteVariants = (path: string) => {
  const normalizedPath = normalizePathname(path);
  const unprefixed = withoutAppBase(normalizedPath);

  const variants = new Set<string>();

  for (const basePath of ALL_BASE_PATHS) {
    variants.add(unprefixed === '/' ? basePath : `${basePath}${unprefixed}`);
  }

  variants.add(unprefixed);

  return Array.from(variants);
};

export const isAppBasePath = (pathname: string) =>
  getRouteVariants(withAppBase()).includes(normalizePathname(pathname));

export const webappPaths = {
  login: withAppBase('/login'),
};

export const authPaths = {
  login: withAppBase('/login'),
  forgotPassword: withAppBase('/forgot-password'),
  resetPassword: withAppBase('/reset-password'),
};

export const onHoldReason = {
  email: 'email',
  subscription: 'subscription',
  payment: 'payment',
  trial: 'trial',
};

export const appPaths = {
  base: withAppBase(),
  check: withAppBase('/check'),
  notFound: '*',
  website: '/',
};

export const accountRoutes = {
  checkout: 'checkout',
  billingInformation: 'billing-information',
};

export const drawerKeys = {
  themeOverviewTab: 'themeOverviewTab',
} as const;
